import { createI18n } from "vue-i18n";

import en from "@/i18n/en.json";
import pl from "@/i18n/pl.json";

const messages = {
  en,
  pl,
};

/**
 * Determines the initial locale for the application.
 * - Checks the browser's preferred language (`navigator.language`).
 * @returns The determined locale string ('en' or 'pl').
 */
function getInitialLocale(): string {
  const browserLanguage = navigator.language.split("-")[0]; // e.g., 'en-US' -> 'en'
  // Check if we support the browser's language
  if (messages[browserLanguage]) {
    return browserLanguage;
  }
  return "en";
}

const initialLocale = getInitialLocale();

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: "en",
  messages,
});

export default i18n;
